module.exports = __webpack_public_path__ + "img/map-observatorio-huancayo.56d2043a.webp";